var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPencil = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 50 50"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#0B1738",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "m38.462 17.901-6.369-6.369M40.584 15.778 34.216 9.41l2.123-2.123a3 3 0 0 1 4.245 0l2.144 2.142a2.976 2.976 0 0 1 0 4.207zM34.216 9.41 9.586 34.039l-3.185 9.554 9.554-3.184 24.629-24.631zM35.277 14.717 14.362 35.631"
}), /*#__PURE__*/React.createElement("path", {
  d: "m9.586 34.039 1.592 1.592h3.184v3.186l1.593 1.592M7.994 38.817l3.184 3.184"
}))));
export default SvgPencil;